import { render, staticRenderFns } from "./ReportCardApp.vue?vue&type=template&id=3338d730&scoped=true"
import script from "./ReportCardApp.vue?vue&type=script&lang=js"
export * from "./ReportCardApp.vue?vue&type=script&lang=js"
import style0 from "./ReportCardApp.vue?vue&type=style&index=0&id=3338d730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3338d730",
  null
  
)

export default component.exports